// extracted by mini-css-extract-plugin
module.exports = {"Thumb":"ChapterPlayer_Thumb__QkeIi","ThumbZoom":"ChapterPlayer_ThumbZoom__3tr7z"};